import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { filter } from 'lodash';
import { COUNTRIES_EXTN, PREFERRED_COUNTRIES } from 'configs/constants';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Input, FormGroup } from 'reactstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { getText } from 'helpers/app/getText';
import moment from 'moment';

const StandardShopQuickshop = (props) => {
  const [selectedPSPType, setSelectedPSPType] = useState('');
  const [isPhoneValidationFailed, setIsPhoneValidationFailed] = useState(false);
  const [phone, setPhone] = useState('');
  const [swishPhone, setSwishPhone] = useState('');
  const [paymentEmail, setPaymentEmail] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const { t, quickshop, addProductToCart, payPOSSession } = props;

  useEffect(() => {
    if (quickshop._id) {
      const product = {
        productID: quickshop.productID,
        productName: quickshop.productName,
        imageURL: quickshop.productImageURL,
        salesPrice: quickshop.salesPrice,
        currency: quickshop.currency,
        vatAmount: quickshop.vatAmount,
        vatPercent: quickshop.vatPercent,
      };

      addProductToCart({
        userId: uuid(),
        webShopID: quickshop.webshopID,
        webShopName: quickshop.webshopName,
        product,
      });
    }
  }, [quickshop]);

  const onPay = () => {
    if (selectedPSPType === 'swish' && swishPhone.length === 0) {
      setIsPhoneValidationFailed(true);
    }
    if (rememberMe) {
      localStorage.setItem('email', paymentEmail);
    } else {
      localStorage.removeItem('email');
    }

    const paymentProvider = filter(Object.values(quickshop.paymentProviderAccounts), { pspType: selectedPSPType })[0];

    const params = {
      salesChannelID: quickshop._id,
      salesChannelType: 'quickshop',
      paymentProviderAccountID: paymentProvider?.paymentProviderAccountID,
      customerEmail: paymentEmail,
      customerPhone: phone,
    };

    payPOSSession(params);
  };

  return (
    <div className="container standard-container">
      <div className="row">
        <div className="col"></div>
        {quickshop.isEnabled && moment().isBetween(moment.utc(quickshop.validPeriod.validFromDate), moment.utc(quickshop.validPeriod.validToDate)) ? (
          <div className="col-md-8">
            <div className="my-3 p-3 bg-white rounded text-center">
              <div className="border-bottom border-gray header-div text-center">
                <img src={'img/logo.jpeg'} className="header-img" />
              </div>
              <img src={quickshop.productImageURL} className="main-prod-img" />
              <div className="media text-muted pt-3 border-bottom">
                <div className="media-body pb-3 mb-0 lh-125 border-gray">
                  <div className="d-flex justify-content-between align-items-between w-100">
                    <label className="product-text text-gray-dark">
                      <b>{quickshop.productName}</b>
                    </label>
                    {quickshop?.productDescription?.length > 0 && (
                      <label className="product-text text-gray-dark">
                        <b>{quickshop.productDescription}</b>
                      </label>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between border-top-black">
                <span className="font-weight-bold">{getText('main:TOTAL')}</span>
                <span className="font-weight-bold">
                  <span id="totalAmount">{quickshop.salesPrice} </span>
                  <span id="totalAmountCurrency">{quickshop.currency}</span>
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="vat-text">{getText('main:WHEREOF_VAT')}</span>
                <span className="text-muted vat-text">
                  <span id="vatAmount">{quickshop.vatAmount}</span>{' '}
                </span>
              </div>
            </div>
            <div className="my-3 p-3 bg-white rounded">
              <div className="form-horizontal receipt-box m-0">
                <p className="mb-0">{getText('main:EMAIL_TEXT')}</p>
                <FormGroup className="text-center email-section row">
                  <label className="col-xl-3">{getText('main:EMAIL')}:</label>
                  <Input type="text" className="col-xl-9" name="email" value={paymentEmail || ''} onChange={(ev) => setPaymentEmail(ev.target.value)} />
                </FormGroup>
                <FormGroup className="text-center email-section row">
                  <label className="col-xl-3">{getText('main:PHONE')}:</label>
                  <ReactPhoneInput
                    onBlur={(ev, country) => {
                      const phone = ev.target.value;
                      const value = phone.replace(`+${country.dialCode}`, '');
                      if (value.substring(0, 1) === '0') {
                        setPhone(`+${country.dialCode}${value.substring(1, value.length)}`);
                      }
                    }}
                    onlyCountries={COUNTRIES_EXTN.map((country) => country.code)}
                    value={phone.length === 0 ? '+46' : phone}
                    countryCodeEditable={false}
                    autoFormat={false}
                    className="col-xl-9 m-0 p-0"
                    inputExtraProps={{ name: 'phone' }}
                    preferredCountries={PREFERRED_COUNTRIES}
                    onChange={(val) => setPhone(val)}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="my-3 p-3 bg-white rounded box-shadow">
              <h5 className="border-bottom border-gray pb-2 mb-0">{getText('main:PAYMENT')}</h5>
              <div className="media text-muted pt-3">
                <div className="media-body mb-0 lh-125">
                  <div className="d-flex flex-column justify-content-between align-items-between w-100">
                    <div className="d-flex justify-content-between flex-column">
                      {quickshop.paymentProviderAccounts &&
                        Object.keys(quickshop.paymentProviderAccounts).map((pspType, idx) => {
                          const account = quickshop.paymentProviderAccounts[pspType];
                          return (
                            <FormGroup key={idx} check>
                              <div className="c-radio">
                                <label className="wd-100">
                                  <Input type="radio" name="radio1" onChange={() => setSelectedPSPType(account.pspType)} />
                                  <span className="fa fa-circle"></span>
                                  {account.pspType}
                                  <div className="pull-right">
                                    <img src={account.pspLogoImageURL} className="prod-img" />
                                  </div>
                                </label>
                              </div>
                            </FormGroup>
                          );
                        })}
                      {selectedPSPType === 'swish' && (
                        <div className="form-group" id="phoneText">
                          <label>{getText('main:MOBILE_PHONE')}</label>
                          <div className="info-tooltip">
                            <em className="fa fa-info-circle" data-tip data-for="mobilePhone"></em>
                            <ReactTooltip id="mobilePhone" effect="solid" className="customTooltip">
                              <span>{getText('main:ENTER_MOBILE_NUMBER')}</span>
                            </ReactTooltip>
                          </div>
                          <ReactPhoneInput onlyCountries={COUNTRIES_EXTN.map((country) => country.code)} value={swishPhone.length === 0 ? '+46' : swishPhone} countryCodeEditable={false} autoFormat={false} inputExtraProps={{ name: 'phone' }} preferredCountries={PREFERRED_COUNTRIES} onChange={(val) => setSwishPhone(val)} />
                        </div>
                      )}
                    </div>
                    {isPhoneValidationFailed && (
                      <div className="form-group" id="phoneMessageBox">
                        <label className="validation-msg">
                          <i className="fa fa-info-circle validation-msg-inner mr-1"></i>
                          <span id="phoneMessage" className="validation-msg-inner">
                            {getText('main:PHONE_VALIDATION_FAILED_MSG')}
                          </span>
                        </label>
                      </div>
                    )}
                    <FormGroup>
                      <label className="c-checkbox">
                        <Input type="checkbox" id="rememberMe" name="rememberMe" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)} />
                        <span className="fa fa-check"></span>
                        {getText(`main:REMEMBER_TEXT`)}
                      </label>
                    </FormGroup>
                    <div className="pb-3 chkbox-text" style={{ textAlign: 'left' }}>
                      {getText('main.PAYMENT_TEXT_LINE1')}{' '}
                      <a href="/webshop/privacy/a9605571-6890-4b68-b6fd-fe6660a5d1c4?lang=" target="_blank">
                        {getText('main:PAYMENT_LINK_LINE1')}
                      </a>{' '}
                      {getText('main.PAYMENT_TEXT_LINE2')}{' '}
                      <a href="/webshop/terms/a9605571-6890-4b68-b6fd-fe6660a5d1c4?lang=" target="_blank">
                        {getText('main:PAYMENT_LINK_LINE2')}
                      </a>
                    </div>
                    <div className="text-center">
                      <button type="button" onClick={() => onPay()} className="btn pay-now-btn btn-success">
                        {getText('main:CONTINUE')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="inactive-quickshop">{getText('main:QUICKSHOP_NOT_ACTIVE_MSG')}</div>
        )}
        <div className="col"></div>
      </div>
    </div>
  );
};

StandardShopQuickshop.displayName = 'StandardShopQuickshop';

StandardShopQuickshop.propTypes = {};

export default StandardShopQuickshop;
